module.exports = __webpack_public_path__ + "img/mini-right-btn.dff08e2b.svg";